export default "__VITE_ASSET__21e24bb2__"